import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';
import { NFAListingColumns } from './nfaListingConfig';
import { Listing } from 'components/shared/TableListing';
import { CalculatedTotalsByLevel, NetFinanceAmountListingEntity } from '../../../types';

export const NetFinanceAmountListing = ({ equipments, attachments, invoice }: CalculatedTotalsByLevel) => {
  const tableData = useMemo(() => {
    const hardCost = equipments.price + attachments.price;
    const fees = equipments.fees + attachments.fees + invoice.fees;
    const taxes = equipments.taxes + attachments.taxes + invoice.taxes;
    const softCost = hardCost > 0 ? Number(((fees + taxes) / hardCost).toFixed(2)) : null;

    return {
      fees,
      taxes,
      hardCost,
      softCost,
      netFinanceAmount: hardCost + fees + taxes,
    };
  }, [equipments, attachments, invoice]);

  return (
    <Listing<NetFinanceAmountListingEntity>
      tableData={[tableData]}
      columns={NFAListingColumns}
      actionPanelTop={() => (
        <Stack>
          <Typography variant="h6" component="span">
            Net Finance Amount
          </Typography>
        </Stack>
      )}
    />
  );
};
